var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view',{attrs:{"name":"header"}}),_c('v-content',{staticStyle:{"padding":"0px 0px 50px 0px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }